import { swSettings } from "app/common/services/swSettings";
import { defaultKeywordState } from "pro-features/components/AutocompleteDigitalMarketing/AutocompleteDigitalMarketingHelper";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const createKeywordUrl = (keyword: string, stateName = defaultKeywordState) => {
    const state = proNavigator.getState(stateName);
    const configId = proNavigator.getConfigId(state);
    const defaultParams = configId ? swSettings.components[configId].defaultParams : undefined;

    return proNavigator.href(stateName, {
        ...defaultParams,
        keyword,
    });
};
